module.exports = __webpack_public_path__ + "img/661.92858039.jpg";